var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAttendance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 96,
    fill: "url(#pattern0_3404_9)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_3404_9",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_3404_9",
    transform: "scale(0.0104167)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_3404_9",
    width: 96,
    height: 96,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAACXBIWXMAAAsTAAALEwEAmpwYAAAB/ElEQVR4nO3cS07DMBSF4awJBmUJxO4Ap0tIlC3ADIZsFsQOQK5AVCikfrX3Ov4/KbMqbc9JGnDT23UAAAAAAAAAUJIZxidzmHfZ+znMO7+vMq+qEb0bX8wwfRo3fty76S51P/Zhuu2H8d3vqx/G17KvcuvhD99bYgmn4f9slBAbfmIJS+FTQmr4kSWshU8JaxfctfBPSli7MB8vuP4xIfviwvxr7+Yb46a30BKWzoSQIz+0yCbtM0ogfMESCL+wqM9x/7iYx/Kxc4Ezobbwi72pYXlTV4Km8GsqoEgJ2sKvrYCsEjSGX2MBSSVoDb/WAmzMP1kFVlEvqrYCbGz42kuoqQCbGr7mEmopwOaGr7kE7Wyp8CkhHksRgmzCknKJpWx0eUvKlJCpxJIyJWTgK0kFrJseU478xDPh+TrvaisluLi1nTMlEH5UCYkLa/+UQPhRJWSuav4pgfBjcHMuAAAAAAAAAKBizI4QxOwIQcyOEMTsCOmvJM/8lNXPqch9ns3OCzIZJTA7Qtm8oNybvjavv8K8IMJXMC+II1/Dzbl87DQ6LyjoBWZsXaJm5gVpLaCZeUGaC2jiR3raC/CYFyRcgMe8IOECPOYFCRfgMS9IuIDNzQuq1T60BMIXLIHwBUsgfMESCF+wBMKXc1y24K8dAAAAAAAAAOjK+wJw4LASHkEBDQAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttendance);
export default __webpack_public_path__ + "static/media/attendance.9fdefc1042bd1bef3dbe0423f399f017.svg";
export { ForwardRef as ReactComponent };